import type { Course } from '../services/courseService';
import { CourseType } from '../services/courseService';

// NASBA-required disclosure helpers for CPE "program announcements" (course detail pages).
// The synced description sections carry learningObjectives, prerequisites, and
// advancedPreparation (see WebinarsCourseSourceSynchronizer / DoceboCourseSourceSynchronizer).

const DESCRIPTION_TYPE_LABELS: Record<string, string> = {
  courseDescription: 'Description',
  learningObjectives: 'Learning Objectives',
  prerequisites: 'Prerequisites',
  advancedPreparation: 'Advance Preparation',
  whoShouldAttend: 'Who Should Attend',
  programContent: 'Program Content',
};

// Section types rendered by NasbaDisclosures (or by the page's own Description
// section), so catch-all loops over course.descriptions should skip them.
export const NASBA_HANDLED_DESCRIPTION_TYPES = new Set([
  'Description',
  'courseDescription',
  'learningObjectives',
  'prerequisites',
  'advancedPreparation',
]);

export function getDescriptionTypeLabel(type: string): string {
  return (
    DESCRIPTION_TYPE_LABELS[type] ??
    type.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase())
  );
}

// NASBA "type of formal learning program" (instructional delivery method).
const MEETING_FORMAT_IN_PERSON = 2;

export function getDeliveryMethod(course: Course): string {
  if (course.courseType === CourseType.OnDemand) {
    return 'QAS Self Study';
  }
  return course.meetingFormat === MEETING_FORMAT_IN_PERSON ? 'Group Live' : 'Group Internet Based';
}

export function findDisclosureSectionText(course: Course, type: string): string | undefined {
  const text = course.descriptions?.find((d) => d.descriptionType === type)?.description;
  return text?.trim() ? text : undefined;
}
